import * as React from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import Checkbox from './Checkbox';
import StarRating from './StarRating';
import { FilterValueProps } from '../models/components/Filter';
import Translate from './Translate';
import { camelCase } from '@kurtosys/ksys-app-template/dist/utils/changeCase';

const FilterListItem = styled<any, any>('li', 'filterListItem', 'filterValue')`
    ${propStyles};
`;

const FilterValueLabel = styled<any, any>(
    'div',
    'filterValueLabel',
    'filterValue'
)`
    ${propStyles};
`;

const checkboxStyleProps = {
    height: '1.4em',
    width: '1.4em',
    marginX: 'xs',
};

const starIconStyleProps = {
    height: '1.4em',
    width: '1.4em',
};

@observer
class FilterValue extends Component<FilterValueProps> {
    render() {
        const {
            theme,
            label,
            checked,
            disabled = false,
            onChange,
            active,
            ui,
            value,
            filterProperty,
            ...props
        } = this.props;

        return (
            <FilterListItem {...props}>
                {ui === 'dropdown' && (
                    <FilterValueLabel
                        data-selected={checked}
                        onClick={onChange}
                        data-metric-id={`filterValue-label-${camelCase(label)}`}
                        cursor={'pointer'}
                        {...theme.FilterDropdownItemValue}
                    >
                        <Translate>{label}</Translate>
                    </FilterValueLabel>
                )}
                {ui !== 'dropdown' && (
                    <Checkbox
                        checked={checked}
                        disabled={disabled}
                        active={active}
                        onChange={onChange}
                        theme={{
                            ...theme,
                            CheckboxChecked: {
                                ...checkboxStyleProps,
                            },
                            CheckboxUnchecked: {
                                ...checkboxStyleProps,
                            },
                        }}
                        metricContext={`filterValue-${filterProperty}-${camelCase(
                            label
                        )}`}
                    >
                        {ui === 'stars' ? (
                            <StarRating
                                rating={value}
                                theme={{
                                    ...theme,
                                    // If not cast as any there is a TS error
                                    // [ts] Spread types may only be created from object types. [2698]
                                    // Seems to be a bug in project version of TS
                                    ...(theme.StarRatingFilterWrapper as any),
                                    StarIcon: {
                                        ...starIconStyleProps,
                                        ...(theme.StarIconFilter as any),
                                    },
                                    StarOutlineIcon: {
                                        ...starIconStyleProps,
                                        ...(theme.StarOutlineIconFilter as any),
                                    },
                                }}
                            />
                        ) : (
                            <FilterValueLabel
                                data-selected={checked}
                                {...theme.FilterItemValue}
                            >
                                <Translate>{label}</Translate>
                            </FilterValueLabel>
                        )}
                    </Checkbox>
                )}
            </FilterListItem>
        );
    }
}

export default withTheme(FilterValue);



// WEBPACK FOOTER //
// ./src/Components/FilterValue.tsx